import { useLocation, useNavigate } from 'react-router-dom'
export const useQueryParams = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search)
  const setQueryParam = (key, value) => {
    queryParams.set(key, value)
    navigate(`?${queryParams.toString()}`)
  }
  return { queryParams, setQueryParam }
}
